import { QueryHookOptions, useQuery } from '@apollo/react-hooks';
import { OutageEvent, Query } from '../../../__generated__/pge-types';
import { getAllOutageEvents } from '../../../queries/outage.query';
import { useEffect } from 'react';
import { useErrorNotification } from '../components/common/error-notification';

export const useGetAllOutageEvents = (options?: QueryHookOptions) => {
  const { data, error, loading, refetch } = useQuery<Query>(
    getAllOutageEvents,
    options,
  );
  const { setErrorNotification } = useErrorNotification();

  useEffect(() => {
    error && setErrorNotification();
  }, [error]);

  return {
    outages: data?.getAllOutageEvents?.events as OutageEvent[],
    error,
    loading,
    refetch,
  };
};
